import { useState } from "react";

import ARCCard from "./ARCCard";
import DropDownMenu from "components/layout/dropdowns/DropDownMenu";
import { useNavigate } from "react-router-dom";
import { useARC } from "providers/ARC/ARCProvider";
import { useFleet } from "providers/FleetProvider";

const sortByOptions = ["Mostly Used", "ARC Name", "ARC Series", "Location"];

const ARCRow = ({ title = "", arcsInfo = [] }) => {
    const { selectARC } = useARC();
    const { arcStatuses } = useFleet();
    const [sortByOption, setSortByOption] = useState(sortByOptions[0]);

    return (
        <div className="flex w-full max-w-full flex-col items-start space-y-4">
            <div className="flex w-full  items-center justify-between">
                <p className="text-h3">{title}</p>
                <div className="flex  items-center justify-between space-x-6">
                    <p className="text-h5">No. of Device: {arcsInfo.length}</p>
                    <div className={`flex w-full  items-center justify-start space-x-1`}>
                        <p className="text-h5">Sort By:</p>
                        <DropDownMenu
                            className="w-50"
                            title="Sort By"
                            dropDownOptions={sortByOptions}
                            selectOption={setSortByOption}
                        />
                    </div>
                </div>
            </div>
            {arcsInfo.length > 0 ? (
                <div className="grid w-full grid-cols-[repeat(auto-fill,17.5rem)] gap-3">
                    {arcsInfo.map((arc) => (
                        <ARCCard
                            key={arc.serialNumber}
                            arc={arc}
                            arcStatus={arcStatuses[arc.serialNumber]}
                            onClick={() => selectARC(arc.serialNumber)}
                            className="max-w-Card"
                        />
                    ))}
                </div>
            ) : (
                <div className="text-h5 flex h-[17.5rem] w-full items-center justify-center rounded-r10 bg-black90">
                    No Online ARC
                </div>
            )}
        </div>
    );
};

export default ARCRow;
